import { render, staticRenderFns } from "./attach.vue?vue&type=template&id=3b8e5746&"
import script from "./attach.vue?vue&type=script&lang=js&"
export * from "./attach.vue?vue&type=script&lang=js&"
import style0 from "./attach.vue?vue&type=style&index=0&id=3b8e5746&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports